import React, { createContext } from "react";

import useTelegrams from "../../hooks/useTelegrams";

const TelegramContext = createContext();

const TelegramProvider = ({ children }) => {
	const { loading, telegrams } = useTelegrams();

	return (
		<TelegramContext.Provider value={{ telegrams, loading }}>
			{children}
		</TelegramContext.Provider>
	);
};

export { TelegramContext, TelegramProvider };